// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-module_switch__ngAVr {
    display: inline-block;
    position: relative;
    width: var(--cw-switch-width, 52px);
    height: var(--cw-switch-height, 32px);
    box-sizing: border-box;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    margin: var(--cw-switch-margin-top, 0) var(--cw-switch-margin-right, 0) var(--cw-switch-margin-bottom, 0) var(--cw-switch-margin-left, 0);
}

.switch-module_switch__ngAVr.switch-module_disabled__x4num {
    cursor: default;
}

.switch-module_input__kDW5A {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    opacity: 0;
    cursor: inherit;
    z-index: 1;
}

.switch-module_track__EbUyr {
    position: absolute;
    inset: 0;
    border-radius: var(--cw-switch-track-border-radius, 16px);
    border: var(--cw-switch-track-border-width, 2px) solid var(--cw-switch-track-border);
    background-color: var(--cw-switch-track-bg);
    box-sizing: border-box;
    transition: background-color 500ms;
}

.switch-module_switch__ngAVr.switch-module_checked__Eu0Pv .switch-module_track__EbUyr {
    background-color: var(--cw-switch-track-bg-checked);
    border-color: var(--cw-switch-track-border-checked);
}

.switch-module_switch__ngAVr:not(.switch-module_disabled__x4num):active .switch-module_track__EbUyr {
    background-color: var(--cw-switch-track-bg-pressed);
    border-color: var(--cw-switch-track-border-pressed);
}

.switch-module_switch__ngAVr.switch-module_disabled__x4num .switch-module_track__EbUyr {
    background-color: var(--cw-switch-track-bg-disabled);
    border-color: var(--cw-switch-track-border-disabled);
}

.switch-module_switch__ngAVr.switch-module_disabled__x4num.switch-module_checked__Eu0Pv .switch-module_track__EbUyr {
    background-color: var(--cw-switch-track-bg-disabled-checked);
    border-color: var(--cw-switch-track-border-disabled-checked);
}

.switch-module_thumb__Fc39C {
    position: absolute;
    top: 50%;
    left: var(--cw-switch-thumb-offset, 4px);
    width: var(--cw-switch-thumb-size, 16px);
    height: var(--cw-switch-thumb-size, 16px);
    border-radius: 50%;
    background-color: var(--cw-switch-thumb-bg);
    transform: translateY(-50%);
    transition: width 300ms, height 300ms, left 300ms, background-color 300ms;
}

.switch-module_switch__ngAVr.switch-module_checked__Eu0Pv .switch-module_thumb__Fc39C {
    width: var(--cw-switch-thumb-size-checked, 28px);
    height: var(--cw-switch-thumb-size-checked, 28px);
    left: calc(var(--cw-switch-width, 52px) - var(--cw-switch-thumb-size-checked, 28px) - var(--cw-switch-thumb-offset-checked, 4px));
    background-color: var(--cw-switch-thumb-bg-checked);
}

.switch-module_switch__ngAVr:not(.switch-module_disabled__x4num):active .switch-module_thumb__Fc39C {
    background-color: var(--cw-switch-thumb-bg-pressed);
}

.switch-module_switch__ngAVr.switch-module_disabled__x4num .switch-module_thumb__Fc39C {
    background-color: var(--cw-switch-thumb-bg-disabled);
}

.switch-module_switch__ngAVr.switch-module_disabled__x4num.switch-module_checked__Eu0Pv .switch-module_thumb__Fc39C {
    background-color: var(--cw-switch-thumb-bg-disabled-checked);
}
`, "",{"version":3,"sources":["webpack://./../../packages/core-widgets/src/switch/switch.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mCAAmC;IACnC,qCAAqC;IACrC,sBAAsB;IACtB,eAAe;IACf,wCAAwC;IACxC,yIAAyI;AAC7I;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,UAAU;IACV,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,yDAAyD;IACzD,oFAAoF;IACpF,2CAA2C;IAC3C,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,mDAAmD;IACnD,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;IACnD,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;IACpD,oDAAoD;AACxD;;AAEA;IACI,4DAA4D;IAC5D,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,wCAAwC;IACxC,wCAAwC;IACxC,yCAAyC;IACzC,kBAAkB;IAClB,2CAA2C;IAC3C,2BAA2B;IAC3B,yEAAyE;AAC7E;;AAEA;IACI,gDAAgD;IAChD,iDAAiD;IACjD,iIAAiI;IACjI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,4DAA4D;AAChE","sourcesContent":[".switch {\n    display: inline-block;\n    position: relative;\n    width: var(--cw-switch-width, 52px);\n    height: var(--cw-switch-height, 32px);\n    box-sizing: border-box;\n    cursor: pointer;\n    -webkit-tap-highlight-color: transparent;\n    margin: var(--cw-switch-margin-top, 0) var(--cw-switch-margin-right, 0) var(--cw-switch-margin-bottom, 0) var(--cw-switch-margin-left, 0);\n}\n\n.switch.disabled {\n    cursor: default;\n}\n\n.input {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n    cursor: inherit;\n    z-index: 1;\n}\n\n.track {\n    position: absolute;\n    inset: 0;\n    border-radius: var(--cw-switch-track-border-radius, 16px);\n    border: var(--cw-switch-track-border-width, 2px) solid var(--cw-switch-track-border);\n    background-color: var(--cw-switch-track-bg);\n    box-sizing: border-box;\n    transition: background-color 500ms;\n}\n\n.switch.checked .track {\n    background-color: var(--cw-switch-track-bg-checked);\n    border-color: var(--cw-switch-track-border-checked);\n}\n\n.switch:not(.disabled):active .track {\n    background-color: var(--cw-switch-track-bg-pressed);\n    border-color: var(--cw-switch-track-border-pressed);\n}\n\n.switch.disabled .track {\n    background-color: var(--cw-switch-track-bg-disabled);\n    border-color: var(--cw-switch-track-border-disabled);\n}\n\n.switch.disabled.checked .track {\n    background-color: var(--cw-switch-track-bg-disabled-checked);\n    border-color: var(--cw-switch-track-border-disabled-checked);\n}\n\n.thumb {\n    position: absolute;\n    top: 50%;\n    left: var(--cw-switch-thumb-offset, 4px);\n    width: var(--cw-switch-thumb-size, 16px);\n    height: var(--cw-switch-thumb-size, 16px);\n    border-radius: 50%;\n    background-color: var(--cw-switch-thumb-bg);\n    transform: translateY(-50%);\n    transition: width 300ms, height 300ms, left 300ms, background-color 300ms;\n}\n\n.switch.checked .thumb {\n    width: var(--cw-switch-thumb-size-checked, 28px);\n    height: var(--cw-switch-thumb-size-checked, 28px);\n    left: calc(var(--cw-switch-width, 52px) - var(--cw-switch-thumb-size-checked, 28px) - var(--cw-switch-thumb-offset-checked, 4px));\n    background-color: var(--cw-switch-thumb-bg-checked);\n}\n\n.switch:not(.disabled):active .thumb {\n    background-color: var(--cw-switch-thumb-bg-pressed);\n}\n\n.switch.disabled .thumb {\n    background-color: var(--cw-switch-thumb-bg-disabled);\n}\n\n.switch.disabled.checked .thumb {\n    background-color: var(--cw-switch-thumb-bg-disabled-checked);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `switch-module_switch__ngAVr`,
	"disabled": `switch-module_disabled__x4num`,
	"input": `switch-module_input__kDW5A`,
	"track": `switch-module_track__EbUyr`,
	"checked": `switch-module_checked__Eu0Pv`,
	"thumb": `switch-module_thumb__Fc39C`
};
export default ___CSS_LOADER_EXPORT___;
